import { useEffect, useState } from "react";
import { Loader2, Share } from "lucide-react";
import { sendShare } from "@/lib/share";

// Fullscreen viewer: "Share this before & after". The link is fetched as soon as the pair shows,
// so the tap opens the phone's share sheet straight away (iPhones refuse it after a slow wait).
export const ShareButton = ({ item, className, testid }) => {
  const [url, setUrl] = useState(null); // null loading · "" failed · link
  useEffect(() => {
    let live = true;
    setUrl(null);
    item.share().then((u) => live && setUrl(u)).catch(() => live && setUrl(""));
    return () => { live = false; };
  }, [item.beforeSrc, item.afterSrc]); // eslint-disable-line react-hooks/exhaustive-deps

  const onClick = async () => {
    if (url) return sendShare(url, item.caption);
    try {
      const u = await item.share();
      setUrl(u);
      sendShare(u, item.caption);
    } catch {
      setUrl("");
    }
  };
  return (
    <button type="button" onClick={onClick} disabled={url === null} data-testid={testid} data-ready={url ? "true" : "false"}
      aria-label="Share this before & after" className={`${className} disabled:opacity-70`}>
      {url === null ? <Loader2 className="h-5 w-5 animate-spin" /> : <Share className="h-5 w-5" />}
      <span className="text-sm font-semibold">
        <span className="sm:hidden">Share</span><span className="hidden sm:inline">Share this before &amp; after</span>
      </span>
    </button>
  );
};
